import styled from 'styled-components'

export const Question = styled.div`
  margin-top: 40px;
`
